<template>
  <el-input
    ref="input"
    :value="value"
    v-bind="$attrs"
    :type="type"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    :autosize="autosize"
    @input="inputHandler"
    @focus="focus"
    @blur="blurHandler"
    @change="changeHandler"
  >
    <slot />
    <slot slot="prefix" name="prefix" />
    <rt-icon v-if="!disabled" slot="suffix" name="rt-base-edit" @click="inputFocus" />
  </el-input>
</template>

<script>
import inputFocusMixins from './inputFocusMixins.js';
export default {
  name: 'RtInput',
  mixins: [inputFocusMixins],
  props: {
    placeholder: {
      type: String,
      default() {
        return this.$tx('暂无', 'xpc.input.novalue');
      }
    },
    value: [String, Number],
    datafieldname: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      typeof: Object,
      default: function () {
        return { maxRows: 3 };
      }
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  methods: {
    inputHandler(newValue) {
      this.$emit('input', newValue, null, this.datafieldname);
    },
    focus() {
      this.$emit('focus');
    },
    blurHandler() {
      this.$emit('blur');
    },
    changeHandler(newValue) {
      this.$emit('change', newValue, null, this.datafieldname);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtInput.vue?7b8a51de